function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24.253 8.756c.436 8.324-5.956 15.426-14.283 15.864a15.093 15.093 0 01-8.861-2.32 10.985 10.985 0 007.508-2.321 5.417 5.417 0 01-4.489-3.638c.801.128 1.62.076 2.399-.155a5.416 5.416 0 01-4.412-5.109 5.429 5.429 0 002.168.386 5.416 5.416 0 01-1.394-6.965 15.09 15.09 0 0010.914 5.573 5.185 5.185 0 013.434-6.482 5.181 5.181 0 015.546 1.683 9.076 9.076 0 003.329-1.317 5.038 5.038 0 01-2.399 2.942 9.068 9.068 0 003.019-.851 5.049 5.049 0 01-2.479 2.71z"
});

var SvgTwitterLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 28"
}, props), _ref);

export default SvgTwitterLogo;